import axios, { CancelTokenSource } from 'axios';

import { Configuration } from '../config';

const {
  config: { API_ENDPOINT, RTR_ENDPOINT },
} = new Configuration();

export const api = axios.create({
  withCredentials: true,
  baseURL: API_ENDPOINT,
  xsrfCookieName: 'csrf_token',
  xsrfHeaderName: 'X-CSRF-TOKEN',
});

export const rtr = axios.create({
  baseURL: RTR_ENDPOINT,
});

interface CancelablePromise<T> extends Promise<T> {
  cancel: CancelTokenSource['cancel'];
}

export const cancelable = <T>(
  fn: (...args: any[]) => Promise<T>,
): ((...args: any[]) => CancelablePromise<T>) => (...args: any[]) => {
  const source = axios.CancelToken.source();
  const apiRequest = fn.apply(undefined, [...args, source.token]);
  (apiRequest as CancelablePromise<T>).cancel = source.cancel;
  return apiRequest as CancelablePromise<T>;
};
